import React from "react";

/** Kiba's face: used as the AI icon everywhere in the chat UI. */
export const KIBA_AVATAR_SRC = "/kiba-ai-avatar.jpg";

type Props = {
  size?: number;
  ring?: boolean;      // gold ring around the avatar
  className?: string;
};

export default function KibaAvatar({ size = 32, ring = true, className = "" }: Props) {
  return (
    <img
      src={KIBA_AVATAR_SRC}
      alt="Kiba"
      width={size}
      height={size}
      draggable={false}
      className={`rounded-full object-cover flex-shrink-0 bg-[#0A1628] ${ring ? "ring-2 ring-[#FFC93A]" : ""} ${className}`}
      style={{ width: size, height: size }}
    />
  );
}
